
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createAdmin,fetchProgrammes } from "../../redux/actions/AdminActions";
import { fetchRoles } from "../../redux/actions/roleActions";

import {
  fetchDistricts,
  fetchMunicipalities,
} from "../../redux/actions/locationActions";

const CreateAdmin = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    role_id: "",
    programme_id: "", // ✅ Added programme_id
    district_id: "",
    municipality_id: "",
  });

  // ✅ Map state slices
  const { loading, error, createSuccess } = useSelector((state) => state.admin);
  const { roles = [] } = useSelector((state) => state.role);
  //const { programmes = [] } = useSelector((state) => state.programme); // ✅ New slice
  const { programmes = [] } = useSelector((state) => state.admin);
  const { districts = [] } = useSelector((state) => state.districtsData);
  const { municipalities = [] } = useSelector((state) => state.municipalitiesData);

  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(fetchProgrammes()); // ✅ Fetch programmes
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   // Get full names based on selected IDs
  //   const selectedDistrict = districts.find((d) => d.id === parseInt(formData.district_id));
  //   const selectedMunicipality = municipalities.find((m) => m.id === parseInt(formData.municipality_id));
  //   const selectedProgramme = programmes.find((p) => p.id === parseInt(formData.programme_id)); // ✅ New

  //   const payload = {
  //     ...formData,
  //     district: selectedDistrict?.name || "",
  //     municipality: selectedMunicipality?.name || "",
  //     programme: selectedProgramme?.name || "", // ✅ Send programme name too
  //   };

  //   dispatch(
  //     createAdmin(payload, () => {
  //       setFormData({
  //         username: "",
  //         email: "",
  //         phone: "",
  //         password: "",
  //         role_id: "",
  //         programme_id: "", // ✅ Reset
  //         district_id: "",
  //         municipality_id: "",
  //       });
  //     })
  //   );
  // };
const handleSubmit = (e) => {
  e.preventDefault();

  // Get full names based on selected IDs
  const selectedDistrict = districts.find((d) => d.id === parseInt(formData.district_id));
  const selectedMunicipality = municipalities.find((m) => m.id === parseInt(formData.municipality_id));
  const selectedProgramme = programmes.find((p) => p.id === parseInt(formData.programme_id));

  const payload = {
    ...formData,
    district_id: formData.district_id ? parseInt(formData.district_id) : null,
    municipality_id: formData.municipality_id ? parseInt(formData.municipality_id) : null,
    programme_id: formData.programme_id ? parseInt(formData.programme_id) : null,
    district: selectedDistrict?.name || null,
    municipality: selectedMunicipality?.name || null,
    programme: selectedProgramme?.name || null,
  };

  dispatch(
    createAdmin(payload, () => {
      setFormData({
        username: "",
        email: "",
        phone: "",
        password: "",
        role_id: "",
        programme_id: "",
        district_id: "",
        municipality_id: "",
      });
    })
  );
};

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Admin</h1>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
            Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
          </div>
        )}

        {createSuccess && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded mb-4">
            Admin created successfully!
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {[
            { label: "Username", name: "username", type: "text" },
            { label: "Email", name: "email", type: "email" },
            { label: "Phone", name: "phone", type: "text" },
            { label: "Password", name: "password", type: "password" },
          ].map(({ label, name, type }) => (
            <div key={name}>
              <label className="block text-gray-700 font-medium mb-1">{label}</label>
              <input
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                placeholder={`Enter ${label.toLowerCase()}`}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
              />
            </div>
          ))}

          {/* Role Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Role</label>
            <select
              name="role_id"
              value={formData.role_id}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-cyan-500"
            >
              <option value="">Select Role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.role_name}
                </option>
              ))}
            </select>
          </div>

          {/* Programme Dropdown ✅ */}
          
<div>
  <label className="block text-gray-700 font-medium mb-1">Programme</label>
  <select
    name="programme_id"
    value={formData.programme_id || ""}
    onChange={handleChange}
    required
    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-cyan-500"
  >
    <option value="">Select Programme</option>
    {programmes.map((programme) => (
      <option key={programme.id} value={programme.id}>
        {programme.name}
      </option>
    ))}
  </select>
</div>


          {/* District Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">District</label>
            <select
              name="district_id"
              value={formData.district_id}
              onChange={handleChange}
             
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white"
            >
              <option value="">Select District</option>
              {districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.name}
                </option>
              ))}
            </select>
          </div>

          {/* Municipality Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Municipality</label>
            <select
              name="municipality_id"
              value={formData.municipality_id}
              onChange={handleChange}
             
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white"
            >
              <option value="">Select Municipality</option>
              {municipalities.map((municipality) => (
                <option key={municipality.id} value={municipality.id}>
                  {municipality.name}
                </option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
              loading ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {loading ? "Creating..." : "Create Admin"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateAdmin;
